// Bookings.jsx
import { useEffect, useState } from "react";
import { deleteBooking, getBookings, updateBookingStatus } from "../../services/bookingService";


export default function Bookings() {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getBookings().then(data => {
            setBookings(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch bookings:", err);
        });
    }, []);

    const handleDelete = (bookingId) => {
        const conf = window.confirm("Are you sure you want to delete this booking?");
        if (!conf) {
            return;
        }
        deleteBooking(bookingId).then(() => {
            setBookings(bookings.filter(booking => booking.id !== bookingId));
            alert("booking deleted successfully!");
        }).catch(err => {
            console.error("Failed to delete booking:", err);
        });
    };

    const handleConfirm = (bookingId) => {
        updateBookingStatus(bookingId, 'confirmed').then(() => {
            const updatedBookings = bookings.map(booking => {
                if (booking._id === bookingId) {
                    return { ...booking, status: 'confirmed' };
                }
                return booking;
            });
            setBookings(updatedBookings);
            alert("Booking confirmed successfully!");
        }).catch(err => {
            console.error("Failed to confirm booking:", err);
        });
    }

    const handleCancel = (bookingId) => {
        updateBookingStatus(bookingId, 'canceled').then(() => {
            const updatedBookings = bookings.map(booking => {
                if (booking._id === bookingId) {
                    return { ...booking, status: 'canceled' };
                }
                return booking;
            });
            setBookings(updatedBookings);
            alert("Booking canceled successfully!");
        }).catch(err => {
            console.error("Failed to cancel booking:", err);
        });
    };

    return (
        <section className="trips">
            <header className="trips-header">
                <h1>Bookings</h1>
                {/* <Link to="/admin/bookings/new" className="btn-primary">+ New Booking</Link> */}
            </header>


            <div className="trip-grid">
                {!loading && bookings.length === 0 && <p>No bookings found.</p>}
                {bookings && bookings.map((cat, i) => (
                    <article className="trip-card" key={i}>
                        <div className="trip-card-top">
                            <h3>{cat.user.name}</h3>
                            <h4>{cat.user.email}</h4>
                            <h3>{cat.user.phone}</h3>
                        </div>
                        <p className="meta"> {cat.trip.title}</p>
                        <p className="meta">Price: {cat.totalPrice}</p>
                        <p className="meta">Number of People: {cat.totalPersons}</p>
                        <p className="meta">Date: {cat.date}</p>
                        <p className="meta">Status: {cat.status}</p>

                        <div className="flex row gap-10">
                            {cat.status === 'pending' ? <button onClick={() => handleConfirm(cat._id)} className="btn-primary">Confirm</button>
                            : cat.status === 'confirmed' ? <button onClick={() => handleCancel(cat._id)} className="btn-danger">Cancel</button> :
                             <></>}
                            <button onClick={() => handleDelete(cat._id)} className="btn-danger">Delete</button>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}